import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de90fa80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = {
  key: 0,
  class: "dialog-icon"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "dialog-title"
}
const _hoisted_6 = {
  key: 1,
  class: "dialog-content"
}
const _hoisted_7 = {
  key: 0,
  class: "modal-footer"
}

import { onMounted, ref, watch, computed } from 'vue';
  import { ColorVariants } from '@/constants';
  import { Modal } from 'bootstrap';
  import { useI18n } from 'vue-i18n';
  // 这里可能弹窗不是全局app实例下的，需要单独引入
  // utils/modal.ts
  import AppLoadingButton from '@/components/loading-button.vue';

  export type DialogBtn = {
    text: string,
    click?: Function,
    style?: ColorVariants,
    disabled?: boolean,
    loading?: boolean
  }

  export interface DialogProps {
    isCenter?: boolean,           // 是否垂直居中
    visible?: boolean,            // v-model:visible
    showWarnIcon?: boolean,       // 是否显示警告图标
    title?: string,               // 标题
    content?: string,            // 内容
    btns?: DialogBtn[],          // 多个按钮
    btnText?: string,            // 单个按钮文字
    btnStyle?: ColorVariants     // 单个按钮样式
  }

  interface DialogEmits {
    (event: 'update:visible', visible: boolean): boolean;
    (event: 'close'): void;
    (event: 'confirm'): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    isCenter: { type: Boolean, default: true },
    visible: { type: Boolean },
    showWarnIcon: { type: Boolean, default: false },
    title: { default: '' },
    content: { default: '' },
    btns: null,
    btnText: { default: '' },
    btnStyle: { default: ColorVariants.primary }
  },
  emits: ["update:visible", "close", "confirm"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:visible', visible: boolean): boolean;
    (event: 'close'): void;
    (event: 'confirm'): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { isCenter: boolean, visible?: boolean, showWarnIcon: boolean, title: string, content: string, btns?: DialogBtn[], btnText: string, btnStyle: ColorVariants }

  
  

  const iconWarn = require('@/assets/icon/warn.png');
  const modalRef = ref();
  let modalInstance: Modal;

  onMounted(() => {
    modalInstance = new Modal(modalRef.value, {
      keyboard: false,
      backdrop: 'static'
    });
    Boolean(props.visible) ? modalInstance.show() : modalInstance.hide();
  });

  const handleClose = () => {
    emits('update:visible', false);
    emits('close');
  };
  const handleConfirm = () => {
    emits('confirm');
  };

  const { t } = useI18n();

  const defaultBtns = [
    {
      text: t('Close'),
      style: ColorVariants.outlinePrimary,
      click: handleClose
    },
    {
      text: t('Confirm'),
      style: ColorVariants.primary,
      click: handleConfirm
    },
  ];

  const btns = computed<DialogBtn[]>(() => {
    return props.btns || (props.btnText ? [
      {
        text: props.btnText,
        style: props.btnStyle || ColorVariants.primary,
        click: handleConfirm
      }
    ] : defaultBtns);
  });

  const handleClick = async (btn: DialogBtn) => {
    if (btn.click) {
      return btn.click();
    }
  };

  watch(() => props.visible, val => {
    Boolean(val) ? modalInstance.show() : modalInstance.hide();
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "modalRef",
    ref: modalRef,
    class: "modal fade"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["modal-dialog modal-dialog-scrollable", {'modal-dialog-centered': __props.isCenter}]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: handleClose
          })
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["dialog-container d-flex flex-wrap", {'align-items-center': !props.content}])
          }, [
            (props.showWarnIcon)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("img", {
                    src: _unref(iconWarn),
                    class: "icon"
                  }, null, 8, _hoisted_4)
                ]))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "title", {}, () => [
              (props.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(props.title), 1))
                : _createCommentVNode("", true)
            ]),
            (props.content)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(props.content), 1))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "default")
          ], 2)
        ]),
        (_ctx.$slots.footer || _unref(btns).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _renderSlot(_ctx.$slots, "footer"),
              (!_ctx.$slots.footer && _unref(btns).length)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["dialog-btn-group", {'len-2': _unref(btns).length === 2}])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(btns), (item, index) => {
                      return (_openBlock(), _createBlock(AppLoadingButton, {
                        key: index,
                        pill: "",
                        variant: item.style,
                        disabled: item.disabled,
                        loading: item.loading,
                        onClick: ($event: any) => (handleClick(item))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.text), 1)
                        ]),
                        _: 2
                      }, 1032, ["variant", "disabled", "loading", "onClick"]))
                    }), 128))
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 2)
  ], 512))
}
}

})